module.exports = __webpack_public_path__ + "img/coupon_check_bg.33b080ac.png";